<template>
  <v-main>
    <v-app-bar
      fixed
      color="grey lighten-4"
      dense
      flat
    >
      <v-btn
        icon
        :to="($i18n.locale == 'en') ? '/en' : '/'"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>開発者について</v-toolbar-title>

    </v-app-bar>

    <v-container mt-12 py-6 px-6>
      <p>フリーランス歴15年くらいの企画＆開発者です。</p>

      <p>現在は、某プロジェクトに参加、主にフロントエンド開発を担当しています。</p>

      <p>フロントエンド技術である Vue.js に興味があり、こちらのアプリも Vue.js を利用してリニューアルしました。<br>
      開発の請負もしていますので、お気軽にご相談ください。</p>

      <v-btn
        class="mt-4"
        color="primary"
        depressed
        href="https://forms.gle/abDpKNHjYeyppiVb6"
        target="_blank"
      >
        お問い合わせフォーム
      </v-btn>

      <p class="mt-8">2020年9月4日</p>
    </v-container>
  </v-main>
</template>

<script>
export default {
  metaInfo: {
    title: '開発者について',
    meta: [
      { name: 'description', content: 'ポジショニングマップ.COMの開発者についてです。' }
    ]
  }
}
</script>
